import { css } from "@emotion/react"

import COLOR_CODE from "../../../../features/oneClickEstimate/pcb/constant/color"

const inputStyles = {
  input: css`
    width: 100%;
    min-height: 28px;
    padding: 5px 8px 5px 8px;
    font-family: Arial, sans-serif;
    color: inherit;
    resize: vertical;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0px 0px 3px #e6e6e6 inset;
    &::placeholder {
      color: #999999;
    }
    &:focus {
      border-color: #4488ee;
      outline: none;
      box-shadow: 0px 0px 3px #e6e6e6 inset, 0px 0px 2px #4488ee;
    }
  `,
  error: css`
    border-color: ${COLOR_CODE.RED};
  `,
  disabled: css`
    background-color: rgba(239, 239, 239, 0.3);
  `,
}

export default inputStyles
